export default {
	NOT_AUTHORIZED: 'NotAuthorizedException'
};